import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN || "";

const envNumber = (name, fallback) => {
  const rawValue = process.env[name];
  if (!rawValue) return fallback;
  const parsedValue = Number(rawValue);
  return Number.isFinite(parsedValue) ? parsedValue : fallback;
};

export const sentryEnabled = Boolean(dsn);

export const initSentry = () => {
  if (!sentryEnabled) {
    return;
  }

  Sentry.init({
    dsn,
    enabled: sentryEnabled,
    environment:
      process.env.REACT_APP_SENTRY_ENVIRONMENT ||
      process.env.NODE_ENV ||
      "development",
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    tracesSampleRate: envNumber("REACT_APP_SENTRY_TRACES_SAMPLE_RATE", 0),
    // Record a session replay when an error occurs (1 = 100% of error sessions).
    // Background sampling is kept low to stay within the free tier (50/month).
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.05,
    integrations: [
      Sentry.replayIntegration({
        // Mask all text and block all media by default — members' data stays private.
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications.",
      "Network Error",
    ],
    beforeSend(event, hint) {
      const originalException = hint?.originalException;
      const message =
        originalException?.message ||
        event?.exception?.values?.[0]?.value ||
        "";

      if (message.includes("No se pudo conectar al backend")) {
        return null;
      }

      return event;
    },
  });
};

export default Sentry;
